module.exports = __webpack_public_path__ + "img/portal-icon-active.bd53c55b.svg";